import { AnalyticsRequest, GroupBy, Sort } from './PanelTemplatesTheme/PanelTemplatesTheme';
import { Panel } from '../../models/Panel/Panel';
import { WIDGET_LABEL_SIZE } from '../../components/Widget/WidgetLabel/constants';
import ListeningDimensions from '@sprinklr/stories-services/AnalyticsService/ListeningDimensions';
import { DefaultPosition } from '@sprinklr/display-builder/stores/PanelTemplatesStore/PanelTemplatesTheme/constants';

export const TemplateEmojiCloud: Panel = {
    id: 'emoji-cloud',
    name: 'Emoji Cloud',
    description: '',
    tags: ['Standard', 'Word Cloud', 'landscape', 'portrait'],
    widget: {
        id: '1',
        position: {
            width: '1920px',
            height: '1080px',
            top: '0',
            left: '0',
        },
        classes: 'template_wordcloud',
        children: [
            {
                type: 'wordCloud',
                id: '1',
                name: 'Emoji Cloud',
                useGlobalTimePeriod: true,
                analyticsRequests: [
                    // Note: All global variables like reportingEngine, report, filters, and projections
                    // are injected via AnalyticsRequest.getRequests()
                    new AnalyticsRequest({
                        limit: 25,
                        groupBys: [
                            new GroupBy({
                                LISTENING: { source: ListeningDimensions.emoticon },
                                INBOUND_MESSAGE: null, // not supported
                                PLATFORM: null, // not supported
                                BENCHMARKING: null, // not supported
                                PAID: null, // not supported
                                ADVOCACY: null, // not supported
                                TWITTER: null, // not supported
                                RDB_FIREHOSE: null, // not supported
                            }),
                        ],
                        sorts: [
                            new Sort({ order: 'DESC', projections: 0 }),
                            new Sort({ order: 'ASC', groupBys: 0 }),
                        ],
                        timePeriods: [{ key: 'last_7_days' }],
                        additional: {
                            TARGET_LANG_CODE: '',
                        },
                    }) as any,
                ],
                position: DefaultPosition,
                label: {
                    overlap: false,
                    titleText: 'Emoji Cloud',
                    size: WIDGET_LABEL_SIZE.primary,
                    enabled: true,
                },
                options: {
                    player: {
                        playing: true,
                        duration: 15,
                    },
                    spacing: 1,
                    showSentiment: false,
                    smartSize: {
                        enabled: true,
                        mode: 'responsive',
                        size: 'xl',
                    },
                    portrait: {
                        widgetOrientation: 'portrait',
                    },
                },
            },
        ],
    },
};
